"use client";

import { useCallback, useEffect, useState } from "react";

import { completeMessagingPromptRequest } from "@/lib/completeMessagingPromptRequest";
import {
  MESSAGING_PROMPT_REQUEST_EVENT,
  type MessagingPromptRequest,
} from "@/lib/messagingPromptRequest";
import { readMessagingPromptRequest } from "@/lib/readMessagingPromptRequest";

export function useMessagingPromptRequest(viewerScope: string | undefined) {
  const [state, setState] = useState<{
    request: MessagingPromptRequest | null;
    viewerScope?: string;
  }>({ request: null });

  useEffect(() => {
    if (!viewerScope) {
      setState({ request: null });
      return;
    }

    const refresh = () => {
      setState({ request: readMessagingPromptRequest(viewerScope), viewerScope });
    };
    refresh();
    window.addEventListener(MESSAGING_PROMPT_REQUEST_EVENT, refresh);
    return () => window.removeEventListener(MESSAGING_PROMPT_REQUEST_EVENT, refresh);
  }, [viewerScope]);

  const complete = useCallback(() => {
    completeMessagingPromptRequest(viewerScope);
    setState({ request: null, viewerScope });
  }, [viewerScope]);

  return {
    complete,
    request: state.viewerScope === viewerScope ? state.request : null,
  };
}
